/**
 * List of all 610 (as of February 2nd 2026) Finanzämter in Germany.
 *
 * Obtained from XML download of "GemFA 2.0" available at:
 * https://www.bzst.de/DE/Service/Behoerdenwegweiser/Finanzamtsuche/finanzamtsuche.html
 */
export const FinanzamtNummern = new Set([
  '1010',
  '1020',
  '1030',
  '1040',
  '1055',
  '1060',
  '1075',
  '1085',
  '1113',
  '1114',
  '1116',
  '1117',
  '1118',
  '1119',
  '1120',
  '1121',
  '1123',
  '1124',
  '1125',
  '1127',
  '1129',
  '1130',
  '1131',
  '1132',
  '1133',
  '1134',
  '1135',
  '1136',
  '1137',
  '1138',
  '1191',
  '2111',
  '2113',
  '2115',
  '2116',
  '2117',
  '2118',
  '2120',
  '2122',
  '2124',
  '2125',
  '2126',
  '2127',
  '2128',
  '2129',
  '2130',
  '2131',
  '2137',
  '2201',
  '2210',
  '2216',
  '2217',
  '2220',
  '2227',
  '2228',
  '2230',
  '2235',
  '2241',
  '2242',
  '2243',
  '2244',
  '2245',
  '2246',
  '2247',
  '2248',
  '2249',
  '2250',
  '2251',
  '2313',
  '2314',
  '2315',
  '2316',
  '2317',
  '2318',
  '2319',
  '2320',
  '2321',
  '2322',
  '2323',
  '2324',
  '2325',
  '2326',
  '2327',
  '2328',
  '2330',
  '2333',
  '2334',
  '2335',
  '2336',
  '2338',
  '2340',
  '2341',
  '2343',
  '2344',
  '2345',
  '2346',
  '2347',
  '2348',
  '2349',
  '2350',
  '2351',
  '2352',
  '2353',
  '2354',
  '2355',
  '2356',
  '2357',
  '2358',
  '2360',
  '2361',
  '2363',
  '2364',
  '2365',
  '2366',
  '2367',
  '2368',
  '2369',
  '2370',
  '2380',
  '2381',
  '2382',
  '2384',
  '2385',
  '2386',
  '2390',
  '2391',
  '2392',
  '2393',
  '2457',
  '2460',
  '2471',
  '2475',
  '2477',
  '2478',
  '2601',
  '2602',
  '2603',
  '2604',
  '2605',
  '2606',
  '2607',
  '2608',
  '2609',
  '2610',
  '2611',
  '2614',
  '2616',
  '2618',
  '2619',
  '2620',
  '2621',
  '2622',
  '2623',
  '2624',
  '2625',
  '2626',
  '2627',
  '2628',
  '2629',
  '2630',
  '2631',
  '2632',
  '2633',
  '2634',
  '2636',
  '2637',
  '2638',
  '2639',
  '2640',
  '2641',
  '2642',
  '2644',
  '2645',
  '2646',
  '2701',
  '2702',
  '2706',
  '2708',
  '2709',
  '2710',
  '2713',
  '2719',
  '2722',
  '2723',
  '2724',
  '2726',
  '2727',
  '2729',
  '2730',
  '2731',
  '2732',
  '2734',
  '2735',
  '2740',
  '2741',
  '2742',
  '2743',
  '2744',
  '2801',
  '2804',
  '2805',
  '2806',
  '2807',
  '2808',
  '2809',
  '2810',
  '2811',
  '2812',
  '2813',
  '2814',
  '2815',
  '2816',
  '2818',
  '2819',
  '2820',
  '2821',
  '2822',
  '2823',
  '2830',
  '2831',
  '2832',
  '2833',
  '2834',
  '2835',
  '2836',
  '2837',
  '2838',
  '2839',
  '2840',
  '2841',
  '2842',
  '2843',
  '2844',
  '2845',
  '2846',
  '2847',
  '2848',
  '2849',
  '2850',
  '2851',
  '2852',
  '2853',
  '2854',
  '2855',
  '2856',
  '2857',
  '2858',
  '2859',
  '2861',
  '2862',
  '2863',
  '2864',
  '2865',
  '2869',
  '2870',
  '2871',
  '2874',
  '2876',
  '2877',
  '2878',
  '2879',
  '2880',
  '2881',
  '2882',
  '2883',
  '2884',
  '2885',
  '2886',
  '2887',
  '2888',
  '2889',
  '2890',
  '2891',
  '2892',
  '2893',
  '2895',
  '2896',
  '2897',
  '2899',
  '3046',
  '3048',
  '3049',
  '3050',
  '3051',
  '3052',
  '3053',
  '3056',
  '3057',
  '3061',
  '3062',
  '3064',
  '3065',
  '3102',
  '3103',
  '3105',
  '3106',
  '3107',
  '3108',
  '3110',
  '3112',
  '3114',
  '3115',
  '3116',
  '3117',
  '3118',
  '3119',
  '3202',
  '3203',
  '3204',
  '3207',
  '3208',
  '3209',
  '3210',
  '3213',
  '3214',
  '3215',
  '3217',
  '3218',
  '3220',
  '3222',
  '3223',
  '3224',
  '3227',
  '3228',
  '3231',
  '3232',
  '3236',
  '3237',
  '3238',
  '3239',
  '4069',
  '4070',
  '4072',
  '4075',
  '4079',
  '4080',
  '4081',
  '4082',
  '4084',
  '4086',
  '4087',
  '4090',
  '4151',
  '4154',
  '4155',
  '4156',
  '4157',
  '4159',
  '4161',
  '4162',
  '4165',
  '4166',
  '4170',
  '4171',
  '5101',
  '5102',
  '5103',
  '5105',
  '5106',
  '5107',
  '5109',
  '5111',
  '5112',
  '5113',
  '5114',
  '5115',
  '5116',
  '5117',
  '5119',
  '5120',
  '5121',
  '5122',
  '5123',
  '5124',
  '5126',
  '5128',
  '5130',
  '5131',
  '5132',
  '5133',
  '5134',
  '5135',
  '5139',
  '5147',
  '5170',
  '5171',
  '5172',
  '5173',
  '5174',
  '5176',
  '5201',
  '5202',
  '5203',
  '5204',
  '5205',
  '5206',
  '5207',
  '5208',
  '5209',
  '5210',
  '5211',
  '5212',
  '5213',
  '5214',
  '5215',
  '5216',
  '5217',
  '5218',
  '5219',
  '5220',
  '5221',
  '5222',
  '5223',
  '5224',
  '5230',
  '5270',
  '5271',
  '5272',
  '5301',
  '5302',
  '5303',
  '5304',
  '5305',
  '5306',
  '5307',
  '5308',
  '5309',
  '5310',
  '5311',
  '5312',
  '5313',
  '5314',
  '5315',
  '5316',
  '5317',
  '5319',
  '5321',
  '5322',
  '5323',
  '5324',
  '5325',
  '5326',
  '5327',
  '5328',
  '5329',
  '5330',
  '5331',
  '5332',
  '5333',
  '5334',
  '5335',
  '5336',
  '5337',
  '5338',
  '5339',
  '5340',
  '5341',
  '5342',
  '5343',
  '5345',
  '5346',
  '5347',
  '5348',
  '5349',
  '5350',
  '5351',
  '5359',
  '5371',
  '5372',
  '5373',
  '5374',
  '5375',
  '5376',
  '9101',
  '9102',
  '9103',
  '9104',
  '9105',
  '9106',
  '9107',
  '9108',
  '9109',
  '9110',
  '9111',
  '9112',
  '9113',
  '9114',
  '9115',
  '9116',
  '9117',
  '9119',
  '9121',
  '9123',
  '9124',
  '9125',
  '9126',
  '9127',
  '9131',
  '9132',
  '9134',
  '9138',
  '9139',
  '9140',
  '9141',
  '9142',
  '9143',
  '9144',
  '9145',
  '9146',
  '9147',
  '9148',
  '9149',
  '9151',
  '9152',
  '9153',
  '9154',
  '9156',
  '9157',
  '9159',
  '9161',
  '9162',
  '9163',
  '9168',
  '9169',
  '9170',
  '9171',
  '9181',
  '9182',
  '9183',
  '9184',
  '9185',
  '9187',
  '9188',
  '9189',
  '9201',
  '9202',
  '9203',
  '9204',
  '9205',
  '9206',
  '9207',
  '9208',
  '9211',
  '9212',
  '9216',
  '9217',
  '9218',
  '9220',
  '9221',
  '9222',
  '9223',
  '9227',
  '9228',
  '9229',
  '9230',
  '9231',
  '9232',
  '9235',
  '9238',
  '9240',
  '9241',
  '9244',
  '9247',
  '9248',
  '9249',
  '9252',
  '9254',
  '9255',
  '9257',
  '9258',
  '9259',
  '2171',
  '2173',
  '2175',
  '2190',
  '2184',
  '2186',
  '2189',
  '2191',
  '2187',
  '2172',
  '2183',
  '2180',
  '2188',
  '2179',
  '2182',
  '2185',
  '2176',
  '2177',
  '2178',
  '2181',
  '1115',
  '5380',
]);
